<app-content-header text="Order Details"></app-content-header>

<div>
  <div *ngIf="orderRequestPriceInfo.total === 0">
    <span class="mb-3 lato">No Packages Selected</span>
  </div>
  <div *ngIf="orderRequestPriceInfo.total !== 0">
    <div *ngFor="let packageItem of orderRequest.selectedPackageList">
      <div
        class="mb-3"
      >
        <app-package-item
          [packageItem]="packageItem"
          [showDelete]="true"
          (toggleSelection)="togglePackageDeletion($event)"
        >
        </app-package-item>
      </div>
    </div>
  </div>
</div>
<!-- Total -->
<hr class="view-divider" />
<div class="row no-gutters lato price-text">
  <div class="col text-md">Subtotal</div>
  <div class="text-md">{{ orderRequestPriceInfo.subtotal | currency }}</div>
</div>
<div class="row no-gutters lato price-text">
  <div class="col text-md">Tax ({{ orderRequestPriceInfo.taxRate | percent : '1.2-2' }})</div>
  <div class="text-md">{{ orderRequestPriceInfo.taxTotal | currency }}</div>
</div>
<hr class="view-divider" />
<div class="row no-gutters lato mb-5">
  <div class="col text-md">Total</div>
  <div class="text-md total-text">{{ orderRequestPriceInfo.total | currency }}</div>
</div>

<!-- Tip -->
<ng-container *ngIf="orderRequest.selectedLocation.hasDefaultTipItem">
  <span class="lato text-md">Would you like to tip our amazing team? (optional)</span>
  <div class="row lato text-md">
    <div *ngFor="let tipOption of tipOptions" (click)="setTipPercent(tipOption)" class="tip-options" [ngClass]="{'selected': tipOption === selectedTipOption}">
      <div> {{tipOption }}% </div>
      <div class="price-text"> {{orderRequestPriceInfo.subtotal * (tipOption / 100) | currency}}</div>
    </div>
    <div *ngIf="showCustomOption" (click)="setTipPercent('Custom')" class="tip-options d-flex"  [ngClass]="{'selected': 'Custom' === selectedTipOption}">
      <div class="custom-style"> Custom</div>
    </div>
  </div>
  <div
    class="input-container lato text-md"
    style="width: 100%;"
    *ngIf="selectedTipOption === 'Custom'"
  >
    <span class="input-label">Custom Amount</span>
    <input
      title="Custom Amount"
      type="text"
      class="input"
      (blur)="transformCustomTip($event)"
      [(ngModel)]="customTipAmount"
      min="0"
    >
  </div>
</ng-container>

<!-- Button -->
<hr class="bottom-divider" />
<footer
  class="flex-sm-row flex-column-reverse row no-gutters footer-action div-footer"
>
  <div class="col pr-sm-1">
    <button
      class="btn btn-outline-danger btn-block"
      (click)="back()"
    >Back</button>
  </div>
  <div
    *ngIf="orderRequestPriceInfo.total !== 0"
    class="col pl-sm-1">
    <button
      class="btn btn-danger btn-block ml-sm-1 mb-2"
      (click)="proceed()"
    >Checkout</button>
  </div>
</footer>
